import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { getServiceWorkerRegistration } from "../serviceWorkerRegistration";
import {
  getMessagePreview,
  getTimestampMillis,
  shouldNotifyConversation,
} from "./chatNotificationUtils";

const CHAT_NOTIFICATIONS_ENABLED_KEY = "tecnica-chat-notifications-enabled";

export const getChatNotificationPermission = () => {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission;
};

export const getChatNotificationsEnabled = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(CHAT_NOTIFICATIONS_ENABLED_KEY) !== "false";
};

export const setChatNotificationsEnabled = (enabled) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(
    CHAT_NOTIFICATIONS_ENABLED_KEY,
    enabled ? "true" : "false"
  );
};

export const requestChatNotificationPermission = async () => {
  if (!("Notification" in window)) return "unsupported";

  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    setChatNotificationsEnabled(true);
    await getServiceWorkerRegistration();
  }
  return permission;
};

const showChatNotification = async (conversation) => {
  if (
    getChatNotificationPermission() !== "granted" ||
    !getChatNotificationsEnabled()
  ) {
    return;
  }

  const sender = conversation.lastSenderName || "Técnica";
  const url = `/chat?conversationId=${encodeURIComponent(conversation.id)}`;
  const options = {
    body: getMessagePreview(conversation),
    icon: "/logo192.png",
    badge: "/favicon-32x32.png",
    tag: `chat-${conversation.id}`,
    renotify: true,
    data: { url, conversationId: conversation.id },
  };
  const registration = await getServiceWorkerRegistration();

  if (registration?.showNotification) {
    await registration.showNotification(`Mensaje de ${sender}`, options);
    return;
  }

  new Notification(`Mensaje de ${sender}`, options);
};

export const subscribeToChatNotifications = (userId) => {
  if (!userId || !db) return () => {};

  const previousTimestamps = new Map();
  let initialized = false;
  const conversationsQuery = query(
    collection(db, "conversations"),
    where("participants", "array-contains", userId),
    orderBy("timestamp", "desc")
  );

  return onSnapshot(
    conversationsQuery,
    (snapshot) => {
      snapshot.docs.forEach((conversationDoc) => {
        const conversation = {
          id: conversationDoc.id,
          ...conversationDoc.data(),
        };
        const timestamp = getTimestampMillis(conversation.timestamp);
        const previousTimestamp = previousTimestamps.get(conversation.id) || 0;
        previousTimestamps.set(conversation.id, timestamp);

        if (
          initialized &&
          shouldNotifyConversation({
            conversation,
            userId,
            previousTimestamp,
            activeConversationId:
              new URLSearchParams(window.location.search).get("conversationId") || "",
            documentVisible: document.visibilityState === "visible",
          })
        ) {
          showChatNotification(conversation).catch((error) => {
            console.error("No fue posible mostrar la notificación de chat:", error);
          });
        }
      });

      initialized = true;
    },
    (error) => {
      console.error("No fue posible escuchar notificaciones de chat:", error);
    }
  );
};
